import { ThuChiDTO } from '@/dto/responseDto/thuChi.dto';
import httpAdmin from '@/httpCommon/axiosClient';

class ThuChiService {
    getAllThuChi = async (params: any) => {
        const res = await httpAdmin.get('report/thu_chi', { params });
        return res?.data?.data;
    };

    delete = async (id: string | number) => {
        const res = await httpAdmin.delete(`report/thu_chi/${id}`);
        return res?.data;
    };

    getDetail = async (id: any) => {
        const response = await httpAdmin.get(`/report/thu_chi/${id}`);
        return response?.data;
    };

    createThuChi = async (body: ThuChiDTO) => {
        const res = await httpAdmin.post('/report/thu_chi', body);
        return res?.data;
    };

    update = async (id: string | number, body: ThuChiDTO) => {
        const res = await httpAdmin.put(`/report/thu_chi/${id}`, body);
        return res?.data;
    };
}
export default new ThuChiService();
